// Profile of Adrian Eisenmeier, Japanese. Source of the profile page.
module.exports = {
  headline: 'ディプロム物理学者 • AI専門家 • ソフトウェア開発者',
  summary: 'Adrian Eisenmeierは、AI、ソフトウェアアーキテクチャ、データ保護、セキュリティが実務で交わる領域でシステムを開発し、コンサルティングを行っています。AI支援ソフトウェア開発のためのIntent-Driven Development、PII（個人識別情報）のローカル匿名化、金融データ分析、実践的な研修を手がけています。',
  imageAlt: 'Adrian Eisenmeierのポートレート',
  personal: {
    position: 'pAIoneer Labs GmbH 創業者・代表取締役',
    birthdate: '1985年6月13日',
    nationality: 'ドイツ',
    maritalStatus: '独身',
    languages: 'ドイツ語（母語）、英語（流暢）、オランダ語（基礎レベル）',
    programmingLanguages: 'Python（16年）、R（17年）、C#（9年）、C/C++（11年）、JavaScriptフルスタック（React、TypeScript）（5年）'
  },
  education: [
    {
      period: '2007年〜2016年',
      field: '専攻：物理学、気象学',
      institution: 'Albert-Ludwigs-Universität Freiburg（フライブルク大学）、ドイツ',
      degree: '学位：物理学ディプロム（Diplom-Physiker）'
    }
  ],
  skills: [
    {
      title: 'エージェント型AI・LLMエンジニアリング',
      description: 'エージェント型AIシステム、Intent-Driven Development（IDD）、OpenCodeおよびClaude Codeのワークフロー、エージェント指示とスキル、Python・TypeScript・PHP・C#によるModel Context Protocol（MCP）、vLLM・Ollama・Hugging FaceによるローカルLLMスタック、RAG/GraphRAG/Agentic RAGアーキテクチャ、RAG評価、説明可能なAI（Explainable AI）、プロンプトエンジニアリング、モデルの量子化、PEFT/LoRAによるファインチューニング'
    },
    {
      title: 'データサイエンス・機械学習・信号解析',
      description: 'Scikit-Learn、H2O、TensorFlow-Keras、PyTorch、SciPy、ML.NET、ランダムフォレスト、LSTM、ニューラルネットワーク、ボルツマンマシン、ホップフィールドネットワーク、ジョーダンネットワーク、OpenCV・SkiaSharp・Pillowによるコンピュータビジョンと画像処理、SIFT、SURF、ORB、ラプラス変換とフーリエ変換、SN比解析、時系列分析、時系列予測、ARIMAおよびpyramid Auto-ARIMA、自然言語処理（NLP）、サービスコール分析、KPI集計、予測モデル、FAMEからの移行、Chou Combination Index、医療技術・製薬分野向けの機械学習'
    },
    {
      title: 'ソフトウェアエンジニアリング・フレームワーク・UI',
      description: 'Python、R、C#、C++、C、JavaScript、TypeScript、React、Java、Android、Lua、Bash、PHP、MATLAB、Mathematica、.NET 6/8、C++20、C++/CLI、BeeWare、Toga UI、Xamarin Forms、MAUI、HTML5、CSS、デスクトップ・モバイル・Web向けUI、ソフトウェアアーキテクチャ、バックエンドおよびフルスタックのアーキテクチャ、イベント駆動アーキテクチャ、デジタルツイン'
    },
    {
      title: 'API設計・サービス・システム連携',
      description: 'ASP.NET/ASP、FastAPI、Flask API、Plumber、REST API、gRPC、Swagger/OpenAPI、API設計、サービス契約、マイクロサービスに近いRESTアーキテクチャ、リフレクションを用いたC# gRPCサービス、Python FastAPIバックエンド、Taiga・Jira・Azure DevOpsのAPI連携、ロボティクスおよびIoTサービスとの連携、認証およびバックエンドの統合'
    },
    {
      title: 'データベース・ORM・永続化',
      description: 'SQL、SQL Server、SQLite、MySQL、Azure SQL、Azure Cosmos DB、ORM層としてのEntity FrameworkおよびEntity Framework Core、匿名化データ、時系列データ、ティックデータ、市場データ、気象データ、エネルギーデータ向けのSQLデータベース、ChromaDBとQdrantによるベクトルデータベース、RAG用の文書インデックス、データ品質チェック、レポーティングの検証'
    },
    {
      title: 'クラウド・DevOps・インフラ',
      description: 'LinuxおよびWindowsサーバーの管理、GPUおよびエッジAIのインフラ、Docker、Docker Compose、Podman、Kubernetes、コンテナサービス、オンプレミスのローカルLLMスタック、Azure Functions、IoT Hub、Event Hub、Digital Twins、Key Vault、Time Series Insights、AWS EC2、ECS、S3、Lambda、Azure DevOps、GitLabパイプライン、GitLab RunnerおよびExecutor、Caddy、Nginx、Let\'s Encrypt、ローカルテスト環境、センサーハードウェア上のコンテナオーケストレーション'
    },
    {
      title: 'ダッシュボード・レポーティング・監視',
      description: 'R Shiny、Python Shiny、ShinyProxy、Grafana、Kibana、CheckMKダッシュボード、Zabbix、RMarkdown、Shinyによるログ分析ダッシュボード、Kibanaによる監視、KPIおよびプロセスの可視化、管理会計（コントローリング）システム、統計レポート、日次レポーティングの検証、運用監視ビュー'
    },
    {
      title: 'セキュリティ・データ保護・CRA',
      description: 'Cyber Resilience Act（CRA）の専門家、CRAへの対応準備、セキュア・バイ・デザインおよびセキュリティ・バイ・デフォルト、SBOMとソフトウェアサプライチェーンセキュリティ、脅威モデリング、脆弱性管理、ペネトレーションテストおよびITセキュリティ（Kali、Tails Linux、Metasploit Framework、Nmap）、IoT/OTセキュリティ、Bluetooth Low Energy、Bluetooth Mesh、MQTT、Mosquitto、Presidio、PIIとデータ保護'
    },
    {
      title: 'プロジェクト手法・AIトランスフォーメーション',
      description: 'Lean AI、ユースケース評価、ROI/TCOの算定、プロセス分類、Intent-Driven Developmentの導入支援、IDDとSpec-Driven Development（仕様駆動開発）の違いの整理、バイブコーディングに代わる専門的な開発手法の確立、アジャイル開発、テスト駆動開発、スクラム、Redmine、Jira、Taiga、Mantis、要件定義、ステークホルダーコミュニケーション、リリースコミュニケーション、ConfluenceおよびDoxygenによるドキュメント作成'
    }
  ],
  positions: [
    {
      period: '2026年1月〜現在',
      title: 'AIエンジニア、ソフトウェアアーキテクト、防衛産業向けコンサルタント',
      technologies: 'CUDA, vLLM, Ollama, Hugging Face, MCP Python, MCP TypeScript, MCP PHP, CI/CD GitLab pipelines, Docker, vector databases (ChromaDB, Qdrant), RAG / GraphRAG / Agentic RAG architectures, RAG evals, Explainable AI, Intent-Driven Development, Lean AI, OpenCode, Claude Code',
      description: [
        '全社的なAI戦略の策定と計画における助言業務。Lean AIのプロジェクトマネジメントプロセスに基づくAIユースケースの評価と定義。',
        '投資対効果（ROI）の算定、およびプロセスの種類と経済性に基づくAIユースケースの分類。',
        'エージェント型ソフトウェア開発とエッジコンピューティング：Anthropicに代わるローカル環境の計画と構築。開発チームがClaude Codeと同等のOpenCode環境をオンプレミスで利用できるようにするもので、特にVS-NfD（秘密指定情報・公用限定）に区分されるデータを扱うAIユースケースが対象。',
        'Claude Codeのエージェント指示とスキルセットを、OpenCodeのエージェント指示とOpenCodeスキルへ移行。',
        '30名規模の開発チームが、最初のトークンまでの時間（TTFT）10秒未満で、IDDに基づくエージェント型開発を同時に行うという要件に対する、ハードウェアと調達コストの計画。SWEベンチマークでClaude Codeに迫るローカルLLMを使用。',
        '計画完了後、エージェント型かつマルチモーダルなAIユースケースを具体的に実装。',
        'ソフトウェア開発者を対象としたIntent-Driven Development（IDD）の研修、Spec-Driven Development（仕様駆動開発）との違いの整理、IDDの利点に関するワークショップ。',
        '統制されていないバイブコーディングに代わる専門的な手法として、AI支援ソフトウェア開発のための体系的な開発プロセスを確立。'
      ]
    },
    {
      period: '2025年12月〜2026年4月',
      title: 'ソフトウェア開発者、銀行業界',
      technologies: 'R Shiny',
      description: [
        'グローバル銀行シミュレーション（Global Banking Simulations、GBS）の可視化と評価を行うR Shinyダッシュボードの実装。'
      ]
    },
    {
      period: '2025年9月〜2025年12月',
      title: 'ソフトウェア開発者／AIエンジニア、バーデン＝ヴュルテンベルク州保険歯科医協会（Kassenzahnärztliche Vereinigung Baden-Württemberg、KZV BW）',
      technologies: 'Python, Microsoft Presidio SDK, spaCy NLP models, FastAPI, Beeware, Docker, SQL, data protection / personally identifiable information (PII)',
      description: [
        '世界中のあらゆる言語に対応し、Office文書に含まれる個人データおよび機密データを検出、匿名化し、さらに匿名化を解除できる汎用PIIソフトウェアシステムの設計と実装。',
        'spaCyのNLPモデルとMicrosoft Presidio Data Protection and De-identification SDKを使用。平文と匿名化後の値の対応はSQLデータベースに保存。Swaggerドキュメント付きのDocker化したFastAPI、単体で利用できるPythonライブラリ、ならびにBeewareとネイティブのToga UIによるWindows/macOS向けスタンドアロンアプリケーションとして提供。'
      ]
    },
    {
      period: '2025年8月〜2025年12月',
      title: 'ソフトウェア開発者／AIエンジニア、産業用IoT',
      technologies: 'Python, Docker, Podman, FastAPI, OpenCV, Shiny, Kibana, HTML, CSS, Lua, embedded engineering',
      description: [
        'HailoプロセッサをベースとするAIハードウェアを搭載したスマートステレオカメラのシニアソフトウェア開発者。',
        'PythonとLuaによるリアルタイムの物体検出と評価。センサーハードウェア上で直接動作するコンテナオーケストレーションAPIの開発。Shinyによるログ分析ダッシュボードとKibanaによる監視をコンテナ化し、センサーの電子回路上にデプロイ。HTML、CSS、JavaScriptによる、カメラ自体がホストするWebアプリケーション。'
      ]
    },
    {
      period: '2025年1月〜現在',
      title: 'ソフトウェア開発者／AIエンジニア、KRIKO Engineering GmbH',
      technologies: 'C#, gRPC, Simatic PCS7, SQL, JavaScript, React, Docker, Python, FastAPI, Swagger, PyTorch, CUDA, RAG, GRAG, agents, Hugging Face, R Shiny, GitLab, GitLab runners and executors, Azure DevOps, Taiga and Jira API',
      description: [
        '多機能なエージェント型AIシステムとDevOps自動化を担当するシニアソフトウェアアーキテクト。リフレクションを用いたC# gRPCサービス、およびAzure DevOpsとGitLab上で音声操作によるコード処理を行う自律型AIエージェントの開発。',
        'React/TypeScriptのフロントエンドを備えたPython FastAPIバックエンドアーキテクチャの計画と開発。すべてのシステムコンポーネントを完全にDocker化してデプロイ。コードベースのインテリジェントな分析と、社内文書、マニュアル、研修資料の統合のためのRAG/GRAGパイプラインの実装。',
        'AIが制御するGitLab RunnerおよびExecutorによるCI/CDの自動化、TaigaおよびJiraとの連携、マルチエージェント間通信のためのModel Context Protocol（MCP）。Explainable AI、Arize Phoenix、RAG評価、ハルシネーション検出による品質保証、ならびにR Shinyによる監視とログ分析。'
      ]
    },
    {
      period: '2025年3月',
      title: '研修講師、バーデン＝ヴュルテンベルク州保険歯科医協会（Kassenzahnärztliche Vereinigung Baden-Württemberg、KZV BW）',
      technologies: 'Python, PyTorch, CUDA, Docker, JupyterLab, Google Colab, Hugging Face',
      description: [
        'プロジェクトリーダーおよびチームリーダーを対象とした、生成AIに関する理論と実践のワークショップ。AIの全体像、評価基準、最適なユースケース、従来型の機械学習、時系列分析、信号処理、LLMベースのソリューションの概要。',
        'RAG/GRAGアーキテクチャとLoRA/QLoRAファインチューニングによる、要件に合わせたエッジAIシステム、自律型AIエージェント、チャットボットソリューション、ホスティング戦略、投資分析、総所有コスト（TCO）、データの匿名化、EU AI Actへの準拠。'
      ]
    },
    {
      period: '2024年7月〜2024年8月',
      title: 'ソフトウェア開発者、IoT',
      technologies: 'Azure IoT, Digital Twins, Event Hubs, SQL database, Azure Functions, C# (.NET 8), REST APIs, gRPC, Docker',
      description: [
        '浄水フィルター向けデジタルツインの開発、Dockerによるローカルテスト環境の構築、およびAzureクラウドへの統合。'
      ]
    },
    {
      period: '2024年7月',
      title: '研修講師、出版業界',
      technologies: 'Python, PyTorch, CUDA, Docker, JupyterLab, Google Colab, Hugging Face',
      description: [
        'プロジェクトリーダーおよびチームリーダーを対象とした、生成AIに関する理論と実践のワークショップ。重点は、ユースケースの選定、エッジAI、RAG/GRAG、エージェント、チャットボット、ホスティング戦略、データ保護、EU AI Act、セキュリティコンセプト。'
      ]
    },
    {
      period: '2023年10月〜2025年10月',
      title: '研究開発（AI・ロボティクス）、Hochschule Offenburg（オッフェンブルク応用科学大学）',
      technologies: 'Python, PyTorch, LLMs, ChatGPT, RESTGPT, NanoGPT, Java, Android, REST API, Swagger, C#/C++, MS Azure, Azure DevOps Pipelines, HTML, CSS, JavaScript, Python Shiny',
      description: [
        'デジタルアシスタントの実現、および画像データと音声データに基づく感情の検出と分類のためのAI手法の開発。各種GPTモデルを用いたDocker化プロトタイプ、APIの実装、ならびにオープンモデルをベースにWebデータとユーザー固有のデータで学習させた、代替となるローカルLLMのトレーニング。Shinyダッシュボードによる監視。',
        'テレプレゼンスロボットシステムの制御、およびREST APIによるロボットとサーバーアプリケーションの連携。'
      ],
      pageBreakBefore: true
    },
    {
      period: '2022年8月〜2024年3月',
      title: 'テクニカルリード、スクラムマスター、国際銀行部門、T-Systems',
      technologies: 'FAME, Python, R, RMarkdown, Camunda, Docker, Kubernetes, GitLab, Confluence, Jira, R Shiny',
      description: [
        '国際銀行部門の大規模な移行プロジェクトにおいて、ソフトウェア開発者とデータサイエンティストからなるチームを統率。',
        'チームミーティング、レトロスペクティブ、スクラム・オブ・スクラムズ、リリースレビュー、顧客向けプレゼンテーションの準備と進行。要件定義担当、プロダクトオーナー、チームリードとの調整。',
        '既存のFAMEロジックをRとPythonで再実装し、標準化された統計レポートを生成するRライブラリを開発。PythonによるCamundaエグゼキューターの実装、ワークフロー設定、GitLabパイプライン、Confluenceドキュメントの自動生成。'
      ]
    },
    {
      period: '2021年5月〜2022年7月',
      title: 'ソフトウェア開発者、ソフトウェアアーキテクト、ERGO Group AG',
      technologies: 'C#, C++, Matlab',
      description: [
        'Matlabで書かれた金融商品の評価・管理ソフトウェアをC#で再実装。債券、モーゲージ、スワップ、スワップション、コーラブル債、フローター、スティープナーの時価とキャッシュフローの算出。アーキテクチャ、Entity Framework、SQLite/SQL Server、Azure DevOpsによるCI/CD、Doxygen、C++/CLI、.NET 6、C++20、ユニットテストおよび結合テスト。'
      ]
    },
    {
      period: '2019年5月〜2021年4月',
      title: 'プロジェクトマネージャー、データサイエンティスト、ソフトウェア開発者、印刷業界（B2B）',
      technologies: 'Xamarin Forms, Entity Framework Core, OpenCV, SkiaSharp, Pillow, Docker, Flask API, MS Azure DevOps',
      description: [
        '特許取得済みのセキュリティラベル向けに、偽造検知と堅牢なフィンガープリントの算出を行うアプリケーションの開発を主導。SIFT、SURF、ORB、ラプラス変換、フーリエ変換による画像処理、SN比解析、AndroidおよびiOS向けのCIデプロイ、REST APIとの連携、ハートビートサービス、レスポンスシステム。'
      ]
    },
    {
      period: '2020年2月〜2020年6月',
      title: 'データサイエンティスト、エネルギー技術（B2C）',
      technologies: 'Azure TSI, Azure Cosmos DB, Azure SQL Database, Azure Functions, Azure Key Vault, pyramid ARIMA, Scikit-Learn, TensorFlow-Keras, Confluence, Jira',
      description: [
        '過去のデータと天気予報に基づく、将来のエネルギー消費量の予測。性能指標と品質指標によるARIMA、ランダムフォレスト、LSTMの評価、Azureでの時系列データ処理、Azure Functionsへのデプロイ、日次レポーティングの検証、Confluenceでのドキュメント作成。'
      ]
    },
    {
      period: '2019年9月〜2020年1月',
      title: 'プロジェクトマネージャー、データサイエンティスト、ソフトウェア開発者、eコマース（B2B）',
      technologies: 'Docker, MySQL, .NET Core, Swagger, R Shiny dashboard, ShinyProxy, Caddy',
      description: [
        'オンライン小売向け分析プラットフォームのセキュリティおよび認証コンセプトの立案と設計。DockerベースのRESTアーキテクチャとして実装。'
      ]
    },
    {
      period: '2018年5月〜2019年6月',
      title: 'データサイエンティスト、ソフトウェア開発者、通信業界（B2C）',
      technologies: 'KNIME, Impala Hadoop, Docker, R Shiny, ShinyProxy, Random Forests with Scikit-Learn, neural networks with TensorFlow',
      description: [
        '事業部門とのプロセス分析、ImpalaとKNIMEによるHadoop上の生データ探索、KPI集計のためのRロジック、Shinyダッシュボード、サービスコールのNLP分析、フィールドサービス向けの予測モデル、CIとDockerによる機械学習の本番実装。'
      ]
    },
    {
      period: '2017年4月〜2018年5月',
      title: 'ソフトウェア開発者、産業・IoT（B2C）',
      technologies: 'Xamarin Forms, .NET, Bluetooth Low Energy',
      description: [
        'タイムスイッチのプログラミングと制御を行うモバイルアプリおよびPCソフトウェアの開発。Bluetoothスタック、UDPディスカバリーサービス、ロールアウトツール、3名のチームによる保守プロセス。'
      ]
    },
    {
      period: '2015年〜2017年',
      title: 'システム管理者、Albert-Ludwigs-Universität Freiburg（フライブルク大学）物理学研究所 ITグループ',
      description: [
        'ESXiとXenによるWindowsおよびLinuxイメージの構築と保守。DHCP、CUPS、FOGサーバー、LDAP認証、KISSシステム、UPS（無停電電源装置）の設定。',
        '研究所ネットワーク向けの自動ペネトレーションテストシステム。NMAPスクリプトエンジン、CVE情報に基づくMetasploitプラグイン、SnortによるIDSで構成。'
      ]
    },
    {
      period: '2016年',
      title: '研究員、Albert-Ludwigs-Universität Freiburg（フライブルク大学）物理学研究所',
      technologies: 'C++, CUDA, Python, R',
      description: [
        'パターンマッチング用ニューラルネットワークの開発と認識率の分析。対象は、さまざまな学習則、活性化関数、符号化を用いたボルツマンマシン、LSTMネットワーク、ホップフィールドネットワーク、ジョーダンネットワーク、ならびにNMSスペクトルおよびESRスペクトルのベースライン補正用に学習させたネットワーク。'
      ]
    },
    {
      period: '2012年〜2015年',
      title: '研究員、Albert-Ludwigs-Universität Freiburg（フライブルク大学）物理化学研究所',
      technologies: 'MATLAB, TurboMol, ORCA, Gromacs MD',
      description: [
        'フラボタンパク質のESRおよびNMRパラメータに関するQM/MMシミュレーション、CHARMM力場、エネルギー最小化、リグニンのポテンシャル、熱アンサンブルとシミュレーションボックスのカップリング。'
      ]
    },
    {
      period: '2011年〜2012年',
      title: '研究員、光学／医療技術・薬学',
      technologies: 'Mathematica, Python, R, KNIME',
      description: [
        '機械学習によって眼のレンズの乱視と屈折度数（ディオプトリー）を求めるソフトウェア。特許EP 2814916の実装を含む。加えて、抗がん剤の併用における相乗効果の分析、およびChou Combination IndexのRによるKNIMEノードとしての実装。'
      ]
    },
    {
      period: '2010年〜2012年',
      title: '金融数学',
      technologies: 'C++, Python, R, Bash scripts',
      description: [
        'WKNコードに対応するティックデータとビットコイン価格を取得するプログラム、ビットコイン、DAX、ダウ・ジョーンズ、STOXX 50を対象としたスイングトレード戦略、移動平均の算出。'
      ]
    }
  ]
};
